
import React, { useState,useEffect} from "react";

const documents = [
    {
    id: 10,
    category: "Stakeholder Engagement",
    title: "2021 Annual Stakeholder Workshop Report",
    description: "Summary of the annual stakeholder workshop conducted in 2021 with institutional partners.",
    image: "/assets/p10.png",
    link: "/PDF/StakeholderInsights/Dereja2021AnnualWorkshopReport.pdf",
  },
  {
    id: 1,
    category: "Stakeholder Engagement",
    title: "2022 Annual Stakeholder Workshop – Dire Dawa University",
    description: "Summary of discussions and outcomes from the 2022 annual stakeholder workshop held at Dire Dawa University.",
    image: "/assets/p1.png",
    link: "/PDF/StakeholderInsights/2022DerejaAnnualStakeholderWorkshopDireDawaUniversity.pdf",
  },
  {
    id: 2,
    category: "Stakeholder Engagement",
    title: "2023 Annual Stakeholders Workshops",
    description: "Comprehensive documentation of the 2023 stakeholder workshops conducted with various stakeholders.",
    image: "/assets/p2.png",
    link: "/PDF/StakeholderInsights/2023DerejaAnnualStakeholdersWorkshops.pdf",
  },
  {
    id: 3,
    category: "Monitoring Visit Report",
    title: "Adama Science & Technology University Visit Report",
    description: "Monitoring visit findings and insights from Adama Science and Technology University.",
    image: "/assets/p3.png",
    link: "/PDF/StakeholderInsights/AdamaScienceandTechnologyUniversityMonitoringVisitReport.pdf",
  },
  {
    id: 4,
    category: "Monitoring Visit Report",
    title: "Addis Ababa University Visit Report",
    description: "Monitoring visit findings and insights from Addis Ababa University.",
    image: "/assets/p4.png",
    link: "/PDF/StakeholderInsights/AddisAbabaUniversityMonitoringVisitReport.pdf",
  },
  {
    id: 5,
    category: "Monitoring Visit Report",
    title: "Arba Minch University Visit Report",
    description: "Monitoring visit findings and insights from Arba Minch University.",
    image: "/assets/p5.png",
    link: "/PDF/StakeholderInsights/ArbaMinchUniversityMonitoringVisitReport.pdf",
  },
  {
    id: 6,
    category: "Instructor Seminar",
    title: "Arba Minch Instructor Seminar Report",
    description: "Detailed report of the instructor seminar conducted at Arba Minch University.",
    image: "/assets/p6.png",
    link: "/PDF/StakeholderInsights/Arbamnchinstructorseminarreport.pdf",
  },
  {
    id: 7,
    category: "Career Center Assessment",
    title: "Career Center Functionality – Hawassa and Dilla",
    description: "Assessment report of career center performance at Hawassa and Dilla universities.",
    image: "/assets/p7.png",
    link: "/PDF/StakeholderInsights/Careercenterfunctionality(HawassaandDilla).pdf",
  },
  {
    id: 8,
    category: "Career Center Assessment",
    title: "Career Center Functionality – 1st Round Evaluation",
    description: "First round assessment of the career center functionality across partner institutions.",
    image: "/assets/p8.png",
    link: "/PDF/StakeholderInsights/Careercenterfunctionality1stround.pdf",
  },
  {
    id: 9,
    category: "Monitoring Visit Report",
    title: "CDC Visit – Jigjiga University",
    description: "Monitoring visit findings and insights from Jigjiga University.",
    image: "/assets/p9.png",
    link: "/PDF/StakeholderInsights/CDCvisitJigjiga.pdf",
  },
  {
    id: 11,
    category: "Monitoring Visit Report",
    title: "Dilla University Monitoring Visit Report",
    description: "Monitoring visit findings and insights from Dilla University.",
    image: "/assets/p12.png",
    link: "/PDF/StakeholderInsights/DillaUniversityMonitoringVisit.pdf",
  },
  {
    id: 12,
    category: "Monitoring Visit Report",
    title: "Gondar University Visit Report",
    description: "Report on supervision and orientation of DAAP program of 2024 at Gondar University.",
    image: "/assets/p13.png",
    link: "/PDF/StakeholderInsights/Gondaruniversityvisitreport.pdf",
  },
  {
    id: 13,
    category: "Monitoring Visit Report",
    title: "Haramaya University Visit Summary",
    description: "Monitoring visit findings and insights from Haramaya University.",
    image: "/assets/p14.png",
    link: "/PDF/StakeholderInsights/HaramayaUniversity.pdf",
  },
  {
    id: 14,
    category: "Monitoring Visit Report",
    title: "Hawassa University Monitoring Visit",
    description: "Monitoring visit findings and insights from Hawassa University.",
    image: "/assets/Screenshot20250617144650.jpg",
    link: "/PDF/StakeholderInsights/HawassaUniversityMonitoringVisit.pdf",
  },
  {
    id: 15,
    category: "Instructor Seminar",
    title: "Jimma University Instructor Seminar",
    description: "Detailed report of the instructor seminar conducted at Jimma University.",
    image: "/assets/p16.png",
    link: "/PDF/StakeholderInsights/InstructorSeminarJimmaUniversityreport.pdf",
  },
  {
    id: 16,
    category: "Monitoring Visit Report",
    title: "Jimma University Monitoring Visit",
    description: "Monitoring visit findings and insights from Jimma University.",
    image: "/assets/p12.png",
    link: "/PDF/StakeholderInsights/JimmaUniversity.pdf",
  },
  
];

export default function KnowledgeLibrary() {
  useEffect(() => {
      window.scrollTo(0, 0); 
    }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const itemsPerPage = 6;

  
  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / itemsPerPage);
  const startIndex = page * itemsPerPage;
  const paginatedDocs = filteredDocs.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); 
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-orange mb-6 text-center">
        Knowledge Management Library
      </h1>

      <div className="max-w-2xl mx-auto mb-8">
        <input
          type="text"
          placeholder="Search documents..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
          onChange={handleSearch}
          value={searchTerm}
        />
        <p className="text-sm text-gray-600 mt-2">
          {filteredDocs.length > 0
            ? `Showing ${startIndex + 1}-${Math.min(
                startIndex + paginatedDocs.length,
                filteredDocs.length
              )} of ${filteredDocs.length} documents`
            : `No results found for "${searchTerm}"`}
        </p>
      </div>

      {filteredDocs.length > 0 ? (
        <>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
            {paginatedDocs.map((doc) => (
              <div
                key={doc.id}
                className="bg-white rounded-xl shadow hover:shadow-md p-4"
              >
                <img
                  src={doc.image}
                  alt={doc.title}
                  className="h-40 w-full object-cover rounded-md mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">
                  {doc.title}
                </h3>
                <p className="text-sm text-gray-600">{doc.description}</p>
                <a
                  href={doc.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block text-orange-600 hover:underline text-sm"
                >
                  View Document
                </a>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4">
            <button
              onClick={handlePrev}
              disabled={page === 0}
              className={`px-4 py-2 rounded-md font-semibold ${
                page === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={page >= totalPages - 1}
              className={`px-4 py-2 rounded-md font-semibold ${
                page >= totalPages - 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-20">
          📄 No documents match your search.
        </div>
      )}
    </div>
  );
}